import React, { useEffect } from "react";
import { Observer } from "mobx-react";
import { useStores } from "../../stores/StoreContext";
import { useTracking } from "../../utilities/TrackingUtil";

const Tracking = () => {
  const rootStore = useStores();
  const { authStore, routerStore } = rootStore;

  return (
    <Observer>
      {() => {
        const userData = authStore.userData;
        const pathname = routerStore.location.pathname;

        return <TrackingEffect userData={userData} pathname={pathname} />;
      }}
    </Observer>
  );
};

const TrackingEffect = ({ userData, pathname }) => {
  const { pushPageView } = useTracking(userData);

  useEffect(() => {
    pushPageView(pathname);
  }, [pathname, pushPageView]);

  return null;
};

export default Tracking;
